import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import ViewIcon from "../../../assets/images/right-more.png";
import { getDealersList } from "../../../api/Api";
import { useCookies } from "react-cookie";
import { handleApiError } from "../../../constants/Constants";

export const DealerListContext = createContext({});

export const DealerListContextProvider = ({ children }) => {
  const header = [
    { title: "CUSTOMER CODE", prop: "customerCode" },
    { title: "CUSTOMER NAME", prop: "customerName" },
    { title: "MOBILE NO", prop: "mobile" },
    { title: "REGION ", prop: "region" },
    { title: "STATUS", prop: "status" },
    { title: " ", prop: "action" },
  ];

  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "67b4165e2efc50c984271c80";
  })[0];
  const location = useLocation();
  const currentPage = location?.state?.page;
  const [searchData, setSearchData] = useState("");
  const [pageCount, setPageCount] = useState(currentPage ? currentPage : 1);
  const [totalPage, setTotalPage] = useState(0);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [statusValue, setStatusValue] = useState(0);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [dealersList, setDealersList] = useState([]);
  const [status, setStatus] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      dealersListAPI(pageCount, status, searchData);
    }, 900);
    return () => clearTimeout(timeoutID);
  }, [pageCount, status, searchData]);

  const navigate = useNavigate();

  useEffect(() => {}, [dealersList]);
  const addDealer = () => {
    navigate(RouteConstants.ADD_DEALER);
  };

  const onChangeSearch = (e) => {
    const specialCharacters = /[!@#$%^&*(),.?":{}|<>+\-_\/=;]/;
    if (specialCharacters.test(e.target.value)) {
    }
    setSearchData(e.target.value);
    setPageCount(1);
  };

  const onPageChange = (e) => {
    setPageCount(e);
  };

  const viewDealerDetails = (id) => {
    navigate(RouteConstants.DEALER_DETAILS, {
      state: { id: id, page: pageCount },
    });
  };

  // api for get dealers list

  const dealersListAPI = async (page, status, search) => {
    try {
      setSpinnerStatus(true);
      const response = await getDealersList(page, status, search);
      if (response?.status === 200) {
        setSpinnerStatus(false);
        setDealersList(
          response?.data?.data?.dealers.map((dealer) => ({
            id: dealer?._id,
            customerCode: dealer?.customerCode,
            customerName: dealer?.customerName,
            mobile: dealer?.mobile,
            region: dealer?.region,
            status: (
              <span
                style={{
                  color:
                    dealer?.status === "A"
                      ? "#13BC5B" // Green for Active
                      : dealer?.status === "I"
                      ? "#EB5757" // Red for Inactive
                      : dealer?.status === "D"
                      ? "#dc3545" // Red for Deleted
                      : dealer?.status === "N"
                      ? "#636E72" // Gray for Invited
                      : "#6c757d", // Default color (gray)
                }}
              >
                {dealer?.status === "A"
                  ? "Active"
                  : dealer?.status === "I"
                  ? "Inactive"
                  : dealer?.status === "D"
                  ? "Deleted"
                  : "Invited"}
              </span>
            ),
            action: (
              <div onClick={() => viewDealerDetails(dealer?._id)}>
                <span>
                  <img className="viewClickAdmin" src={ViewIcon} alt="view" />
                </span>
              </div>
            ),
          }))
        );

        setTotalPage(response?.data?.data?.totalPages);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };
  const dealerToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };
  // status filter
  const handleSelect = () => {
    setShowDropdown(false);
  };

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };
  const onClickFilterButton = (statusId) => {
    setPageCount(1);
    setStatus(statusId);
    setShowDropdown(false);
  };

  const providerValue = {
    dealersList,
    header,
    onChangeSearch,
    searchData,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    addDealer,
    permissionAccess,
    viewDealerDetails,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    dealerToLogin,
    buttonText,
    dealersListAPI,
    statusValue,
    selectedStatusId,
    setSelectedStatusId,
    showDropdown,
    handleSelect,
    handleToggle,
    setStatus,
    onClickFilterButton,
  };
  return (
    <DealerListContext.Provider value={providerValue}>
      {children}
    </DealerListContext.Provider>
  );
};
